module.exports = __webpack_public_path__ + "static/img/sz01.27d3511.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sz01.png
// module id = 4vRX
// module chunks = 105